import { Box } from "@mui/material";
import CommonEdit from "../../CommonEdit";

export default function TrackingTab({
  projectData,
  isDisabled,
  setDisabled,
  initializeLoadingToast,
  updateLoadingToast,
}) {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <CommonEdit
        projectData={projectData}
        isDisabled={isDisabled}
        setDisabled={setDisabled}
        initializeLoadingToast={initializeLoadingToast}
        updateLoadingToast={updateLoadingToast}
      />
    </Box>
  );
}
